import PropTypes from 'prop-types'
import GenericSelect from '../../reutilizables/genericSelect/GenericSelect'
import Input from '../../ui/Input'
import styles from './UsuariosFiltros.module.css'

const UsuariosFiltros = ({ fields, values, onChange }) => {
  return (
    <div className={styles.wrapper}>
      {fields.map((field) => (
        <div key={field.key} className={styles.field}>
          <label htmlFor={field.key} className={styles.label}>
            {field.label}
          </label>

          {field.type === 'select' ? (
            <GenericSelect
              id={field.key}
              name={field.key}
              options={field.options || []}
              placeholder={field.placeholder || 'Seleccionar...'}
              value={values[field.key] ?? ''}
              onChange={(value) => onChange(field.key, value)}
            />
          ) : (
            <div className={styles.searchInputWrapper}>
              <i className={`bi bi-search ${styles.searchIcon}`} aria-hidden="true" />
              <Input
                name={field.key}
                value={values[field.key] ?? ''}
                onChange={(e) => onChange(field.key, e.target.value)}
                placeholder={field.placeholder || `Buscar por ${field.label}`}
                className={styles.input}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

UsuariosFiltros.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      type: PropTypes.oneOf(['text', 'select']).isRequired,
      placeholder: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired
        })
      )
    })
  ).isRequired,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default UsuariosFiltros
